import { toast } from 'react-toastify';
import { RAG_ERROR_CODES } from '../constants/errorCodes';

export const displayErrorToast = (errorCode, t) => {
	const error = RAG_ERROR_CODES[errorCode];
	if (error) {
		toast[error.toastLevel](t(`query.quota.${error.langKey}`));
	}
};
